import tokenData from '../../design-tokens/base-tokens.json';
const palette = {
    primary: {
        light: tokenData.tokens.palette.blue.blue300,
        main: tokenData.tokens.palette.blue.blue500,
        dark: tokenData.tokens.palette.blue.blue600
    },
    secondary: {
        light: tokenData.tokens.palette.blue.blue600,
        main: tokenData.tokens.palette.blue.blue700,
        dark: tokenData.tokens.palette.blue.blue700
    },
    error: {
        light: tokenData.tokens.palette.red.red300,
        main: tokenData.tokens.palette.red.red600,
        dark: tokenData.tokens.palette.red.red700
    },
    success: {
        light: tokenData.tokens.palette.green.green400,
        main: tokenData.tokens.palette.green.green500,
        dark: tokenData.tokens.palette.green.green600
    },
    warning: {
        light: tokenData.tokens.palette.yellow.yellow300,
        main: tokenData.tokens.palette.yellow.yellow400,
        dark: tokenData.tokens.palette.yellow.yellow600
    },
    info: {
        light: tokenData.tokens.palette.purple.purple500,
        main: tokenData.tokens.palette.purple.purple600,
        dark: tokenData.tokens.palette.purple.purple700
    },
    text: {
        primary: tokenData.tokens.palette.text.text300,
        secondary: tokenData.tokens.palette.text.text200,
        disabled: tokenData.tokens.palette.text.text100
    }
};
export default palette;
